import { render, staticRenderFns } from "./ObchodnePripady.vue?vue&type=template&id=072e8d82&"
import script from "./ObchodnePripady.vue?vue&type=script&lang=js&"
export * from "./ObchodnePripady.vue?vue&type=script&lang=js&"
import style0 from "./ObchodnePripady.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})


/* hot reload */
if (module.hot) {
  var api = require("C:\\azagent\\_work\\3\\s\\master-v3\\Filip.Client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('072e8d82')) {
      api.createRecord('072e8d82', component.options)
    } else {
      api.reload('072e8d82', component.options)
    }
    module.hot.accept("./ObchodnePripady.vue?vue&type=template&id=072e8d82&", function () {
      api.rerender('072e8d82', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ObchodnePripady.vue"
export default component.exports